import * as React from 'react';
import { Dispatch } from "redux";
import { connect } from "react-redux";

import { RouteComponentProps, withRouter } from "react-router-dom";
import { IBannerTemplate } from "../store/banner/template/types";
import { AppState } from "../store";
import { modifyingActiveBannerTemplateAction } from "../store/banner/template/actions";
import {
    selectActiveBannerTemplate, selectActiveFolders,
    selectIsReloadingActiveFolders,
} from "../store/banner/template/selectors";
import WebWorker from "../components/WebWorker";
import sass from "../components/Sass/sass.parser.worker";

import nunjucks from "../components/nunjucks-service";
import HtmlTemplate, {
    IFileTemplatesProps,
    IOnFileWithDataChangeParams
} from "../components/BannerEditor/HtmlTemplate";
import {
    IModifyingActiveFolders,
    modifyingActiveFolders,
    reLoadActiveFoldersAsyncAction
} from "../store/banner/template/files/actions";
import { IFileData } from "../store/files/filedata/types";
import { saveFileDataAsyncActions } from "../store/files/filedata/actions";
import { IFileWithData } from "../store/files/types";
import { AtLeastOne, IdObjectsWithId } from "../utils";
import { Spin } from "antd";
import { IActiveFolders } from "../store/banner/template/files/types";
import { selectFilesData, selectIsSavingFileData } from "../store/files/selectors";


interface IMatchParams {
}

interface IOwnProps extends RouteComponentProps<IMatchParams> {
}

interface IStateProps {
    filesData: IdObjectsWithId<IFileData>;
    activeBannerTemplate: IBannerTemplate;
    activeFolders: IActiveFolders;
    isReloadingActiveFolders: boolean;
    isSavingFileData: boolean;
}

interface IDispatchProps {
    modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => void;
    modifyingActiveFolders: (params: IModifyingActiveFolders) => void;
    reLoadActiveFolders: () => void;
    saveFileDataAsyncActions: (params: { fileData: AtLeastOne<IFileData, { id: { id: string } }> }) => void;
}

type IProps = IOwnProps & IStateProps & IDispatchProps


const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    filesData: selectFilesData(state),
    activeBannerTemplate: selectActiveBannerTemplate(state),
    activeFolders: selectActiveFolders(state),
    isReloadingActiveFolders: selectIsReloadingActiveFolders(state),
    isSavingFileData: selectIsSavingFileData(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => dispatch(modifyingActiveBannerTemplateAction({ bannerTemplate: value })),
        modifyingActiveFolders: (params: IModifyingActiveFolders) => dispatch(modifyingActiveFolders(params)),
        reLoadActiveFolders: () => dispatch(reLoadActiveFoldersAsyncAction.request({})),
        saveFileDataAsyncActions: (params: { fileData: AtLeastOne<IFileData, { id: { id: string } }> }) => dispatch(saveFileDataAsyncActions.request(params)),
    };
};

interface IState {
    css: string;
}

class HtmlTemplateContainer extends React.PureComponent<IProps, IState> {
    worker: WebWorker;
    env: any;


    constructor(pros: IProps) {
        super(pros);
        this.worker = new WebWorker(sass);
        this.state = {
            css: ''
        }
    }

    loaderGetSource = (name: string) => {
        let result = {
            src: `${name} not found`,
            path: name,
            noCache: true
        };
        const htmlFolder = this.props.activeFolders["html"];
        if (!htmlFolder) {
            result.src = "html folder not found";
            return result
        }
        const file = htmlFolder[name];
        if (file && file.activeFileData) {
            result.src = file.activeFileData.data
        }
        return result
    };
    onSassMessage = (event: any) => {
        if (!event.data) {
            return;
        }
        const { error, css } = event.data;
        if (error) {
            this.props.modifyingActiveBannerTemplate({ template: error });
            return;
        }
        const { "index.html": index, ...rest } = this.props.activeFolders.html;
        if (index && index.activeFileData) {
            this.setState({ css: css }, () => {
                this.props.modifyingActiveBannerTemplate({ template: this.renderHtml() })
            });

        }
    }

    componentDidMount(): void {
        const htmlFolder = this.props.activeFolders.html;
        const scssFolder = this.props.activeFolders.scss;
        if (Object.keys(htmlFolder).length === 0 && htmlFolder.constructor === Object
            || Object.keys(scssFolder).length === 0 && scssFolder.constructor === Object
        ) {
            this.props.reLoadActiveFolders()
        }

        const MyLoader = nunjucks.Loader.extend({
            init: function () {
                // setup a process which watches templates here
                // and call `this.emit('update', name)` when a template
                // is changed
            },

            getSource: this.loaderGetSource
        });
        this.env = new nunjucks.Environment(new MyLoader('/'), {
            autoescape: true,
            tags: {
                blockStart: '{%',
                blockEnd: '%}',
                variableStart: '{$',
                variableEnd: '$}',
                commentStart: '{#',
                commentEnd: '#}'
            }
        });


        this.worker.addEventListener("message", this.onSassMessage);

        const index = htmlFolder["index.html"];
        const main = scssFolder["main.scss"];
        if (main) {
            this.worker.postMessage(scssFolder);
        }
        if (index) {
            this.renderHtml()
        }

    }

    onFileChange = (params: IOnFileWithDataChangeParams) => {
        let folderKey = "";
        if (/^\/.*\/html\//.test(params.fileWithData.path)) {
            folderKey = "html"
        } else if (/^\/.*\/scss\//.test(params.fileWithData.path)) {
            folderKey = "scss"
        }
        const { key, fileWithData } = params;
        if (this.props.modifyingActiveFolders) {
            this.props.modifyingActiveFolders({
                activeFolders: {
                    [folderKey]: {
                        [key]: {
                            ...fileWithData
                        }
                    }
                }
            })
        }

        if (folderKey === "html") {
            const { "index.html": index, ...rest } = this.props.activeFolders.html;
            if (index && index.activeFileData) {
                this.props.modifyingActiveBannerTemplate({ template: this.renderHtml() })
            }
        } else if (folderKey === "scss") {
            this.worker.postMessage(this.props.activeFolders.scss);
        }
    };

    renderHtml = (): string => {
        let template = ""
        try {
            template = this.env.render("index.html", { css: this.state.css });
        } catch (e: any) {
            template = 'HTML: ' + e.toString()
        }
        return template
    }

    renderPreview = () => {
        this.worker.postMessage(this.props.activeFolders.scss);
    }

    reLoadActiveFolders = () => {
        this.props.reLoadActiveFolders()
    };

    componentDidUpdate(prevProps: IProps) {
    }

    onRouteChanged() {
    }

    onSaveFileWithData = (fileWithData: IFileWithData) => {
        if (this.props.saveFileDataAsyncActions) {
            if (!fileWithData.fileDataId) {
                return
            }
            const fileData = this.props.filesData.byId[fileWithData.fileDataId];
            if (fileData && !fileWithData.readonly && fileWithData.activeFileData) {
                if (fileWithData.activeFileData.data) {
                    this.props.saveFileDataAsyncActions({
                        fileData: {
                            id: fileWithData.activeFileData.id,
                            data: fileWithData.activeFileData.data
                        }
                    })
                }
            }
        }
    };

    render() {
        // console.log("HtmlTemplateContainer render........")
        let fileTemplatesProps: IFileTemplatesProps = {
            activeFolders: this.props.activeFolders,
            filesData: this.props.filesData,
            onFileChange: this.onFileChange,
            onReloadFiles: this.reLoadActiveFolders,
            onSaveFileWithData: this.onSaveFileWithData,
            isSavingFileData: this.props.isSavingFileData,
            renderPreview: this.renderPreview,

        };
        return (
            <React.Fragment>
                {this.props.isReloadingActiveFolders ? <Spin />
                    : <HtmlTemplate
                        {...fileTemplatesProps}
                    />
                }
            </React.Fragment>
        )
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(HtmlTemplateContainer));


